jQuery(document).ready(function(){
var swiper = new Swiper(".mySwiper", {
      loop: true,
      spaceBetween: 15,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".mySwiper2", {
      loop: true,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });
 });

jQuery( document ).ready(function() {
Fancybox.bind('[data-fancybox="gallery"]', {
  // Your custom options for a specific gallery
});
});

jQuery(document).ready(function(){
jQuery( ".product-form__buttons,.swym-wishlist-button-bar,.share-button,.fb_iframe_widget" ).wrapAll( "<div class='pr--btns-group'></div>" );

jQuery( ".radio_field, .select_field" ).wrapAll( "<div class='contact__field'></div>" );  
});

//Single product page review heading change
jQuery(document).ready(function() {
       jQuery('.fera-reviews-header-row1 h1').each(function() {
       jQuery(this).replaceWith('<h2>'+$(this).html()+'</h2>');
    });
  jQuery("#CartDrawer-Checkout").text("Checkout");
  jQuery("#checkout").text("Checkout");
 });

//Add onclick attr product-info page Stainless Steel box
jQuery(document).ready(function() {
jQuery('.gt-meta-boxes.v--2 .meta--bx.v--1 p a').attr("onclick", "window.open('corrosion', 'newwindow', 'width=1000, height=600'); return false;");   
});